export const formatIconName = (kebabName: string): string =>
  kebabName
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
